import i18n from 'i18next';

import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import { getLanguage } from './utils/getLanguage';

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    fallbackLng: getLanguage(),
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
